import { Box, Button, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class HorarioCP extends Component {
    constructor(props){
        super(props);
        this.state = {
            lugaresTra: [],
            ubicacionesCentral: [],
            notificaciones: null,
            errores: null,
            loading: false,
            modalBorrar: false,

            busqueda: {
                cpBusqueda: '',
            },

            datoConsulta: [],
            consultaRealizada: false,

            newHorarioCP: {
                lugar: '',
                entrada: '',
                salida: '',
                desde: '',
            },

            horasEntrada: [],

            horarioBorrar: {

            },

        }
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarCambiosBusqueda = this.manejarCambiosBusqueda.bind(this);
        this.manejarCambiosHorario = this.manejarCambiosHorario.bind(this);
        this.manejarEnvioHorario = this.manejarEnvioHorario.bind(this);
        this.manejarBorrar =  this.manejarBorrar.bind(this);
        this.manejarVolver = this.manejarVolver.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
    }
    async componentDidMount(){
        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntrada: datosEntrada,
        });
    }
    render(){
        return (
            <>
                <Container>
                    <h3>Horarios CP</h3>
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <form className='formulario1'  onSubmit={this.manejoEnvioConsulta}>
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='cpBusqueda'  value={this.state.busqueda.cpBusqueda} onChange={this.manejarCambiosBusqueda}>
                                            <option value=''>UBICACION</option>
                                            {this.state.lugaresTra.map((name) =>
                                                <option
                                                key={name.idLugaresTrabajo}
                                                value={name.idLugaresTrabajo}
                                                >{name.lugar}</option>
                                                )}
                                        </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                    {this.state.consultaRealizada
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Centro</StyledTableCell>
                                            <StyledTableCell>Entrada</StyledTableCell>
                                            <StyledTableCell>Salida</StyledTableCell>
                                            <StyledTableCell>Desde</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datoConsulta.map((datos) => (
                                            <StyledTableRow key={datos.idHorarioCP}>
                                                <StyledTableCell>{datos.cp}</StyledTableCell>
                                                <StyledTableCell>{datos.entrada}</StyledTableCell>
                                                <StyledTableCell>{datos.salida}</StyledTableCell>
                                                <StyledTableCell>{datos.desde}</StyledTableCell>
                                                {datos.activo === 0 ? <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarBorrar(datos)}>Borrar</button></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarVolver}>Volver</button>
                            <br/>
                            <br/>
                        </Container>
                    :
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Centro</StyledTableCell>
                                            <StyledTableCell>Entrada</StyledTableCell>
                                            <StyledTableCell>Salida</StyledTableCell>
                                            <StyledTableCell>Desde</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='lugar'  value={this.state.newHorarioCP.lugar} onChange={this.manejarCambiosHorario}>
                                                    <option value=''>UBICACION</option>
                                                    {this.state.lugaresTra.map((name) =>
                                                        <option
                                                        key={name.idLugaresTrabajo}
                                                        value={name.idLugaresTrabajo}
                                                        >{name.lugar}</option>
                                                        )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entrada'  value={this.state.newHorarioCP.entrada} onChange={this.manejarCambiosHorario}>
                                                    <option value=''>ENTRADA</option>
                                                    {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salida'  value={this.state.newHorarioCP.salida} onChange={this.manejarCambiosHorario}>
                                                    <option value=''>SALIDA</option>
                                                    {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.newHorarioCP.desde} onChange={this.manejarCambiosHorario}/></StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioHorario}>Agregar</button>
                            <br/>
                            <br/>
                        </Container>
                    }
                    {this.state.modalBorrar
                    ?
                        <Modal open={this.state.modalBorrar}>
                            <form className='formulario1'>
                                <Box sx={styleModal} >
                                <h3 style={{textAlign:'center'}}>¿Confirmar Baja Horario CP?</h3>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={4}>
                                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        </Modal>
                    :
                        null
                    }
                </Container>
            </>
        )
    }

    async manejoEnvioConsulta(e){
        e.preventDefault();
        if(this.state.busqueda.cpBusqueda === ''){
            this.setState({
                errores: 'Debe seleccionar un CP!',
            })
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
                consultaRealizada: false,
            });

            const cargaUtil = JSON.stringify([this.state.busqueda]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_horarioCP.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
                notificaciones: null,
                loading: false,
            })

            if(exito[0] === 'ok'){
                this.setState({
                    datoConsulta: exito[1],
                    errores: null,
                    notificaciones: null,
                    consultaRealizada: true,
                })
            }
        }
    }

    manejarCambiosBusqueda(e){
        e.preventDefault();
        this.setState({
            consultaRealizada: false,
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    manejarCambiosHorario(e){
        e.preventDefault();
        this.setState({
            consultaRealizada: false,
            errores: null,
            notificaciones: null,
            loading: false,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.newHorarioCP;
            numFunActualizado[clave] = valor;
            return{
                newHorarioCP: numFunActualizado,
            };
        });
    }

    async manejarEnvioHorario(e){
        e.preventDefault();
        if((this.state.newHorarioCP.lugar === '')){
            this.setState({
                errores: 'Debe seleccionar un centro',
            });
        }else if((this.state.newHorarioCP.entrada === '')){
            this.setState({
                errores: 'Debe ingresar el horario de entrada',
            });
        }else if((this.state.newHorarioCP.salida === '')){
            this.setState({
                errores: 'Debe ingresar el horario de salida',
            });
        }else if((this.state.newHorarioCP.desde === '')){
            this.setState({
                errores: 'Debe ingresar la fecha desde',
            });
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            });

            const cargaUtil = JSON.stringify([this.state.newHorarioCP]);

            const control = await fetch(`${Constantes.RUTA_API}/guardar_horarioCP.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });

            //-----------------------------------------------------------------
            if(res === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: 'El horario fue dado de alta correctamente!',
                    loading: false,
                })
            }
        }
    }

    manejarBorrar(datos){
        this.setState({
            modalBorrar: true,
            horarioBorrar: datos,
            notificaciones: null,
        });
    }
    
    manejarVolver(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
            loading: false,
            modalBorrar: false,

            busqueda: {
                cpBusqueda: '',
            },

            datoConsulta: [],
            consultaRealizada: false,

            newHorarioCP: {
                lugar: '',
                entrada: '',
                salida: '',
                desde: '',
            },
        })
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            modalBorrar: false,
            horarioBorrar: {},
        })
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.horarioBorrar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_horarioCP.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito === 'ok'){
            let contador = 0;
            const arr = this.state.datoConsulta;
            arr.map((name) => {
                if(this.state.horarioBorrar.idHorarioCP === name.idHorarioCP){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                errores: null,
                notificaciones: 'El horario fue dado de baja!',
                modalBorrar: false,
                datoConsulta: arr,
            })
        }
    }
}

export default HorarioCP